import { createStore } from 'vuex';
import modules from './modules';
import { StoreState } from './models/store.interface';

const store = createStore<StoreState>({
   state: {},
   getters: {},
   mutations: {},
   actions: {},
   modules,
});

export default store;
